<template>
  <div class="jumbotron">
    <div class="row">
      <div class="col">
        <h5>Select Your Service Specialties</h5>
      </div>
    </div>
    <div class="row">
      <div v-for="category in selectedCategories" :key="category.id" class="col-md-4">
        <button class="btn btn-secondary remove-button">{{ category }}</button>
        <div class="custom-control custom-checkbox" v-for="specialty in specialties[category]" :key="specialty.id">
          <input class="custom-control-input" type="checkbox" v-bind:id="specialty" v-bind:value="specialty" v-model="selectedSpecialties">
          <label class="custom-control-label" v-bind:for="specialty">{{ specialty }}</label>
        </div>
      </div>
    </div>
    <div class="row row-margin row-margin-top">
      <div class="col-md-4">
        <h5>Select Package:</h5>
      </div>
      <div class="col">
        <p class="d-inline">Basic</p>
        <label class="switch">
          <input v-model="productType" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline">Pro</p>
      </div>
    </div>
    <div class="row row-margin">
      <div class="col-md-4 my-auto">
        <h5>Monthly Total:</h5>
      </div>
      <div class="col-md-3 text-center my-auto">
        <h5 class="total-cost">${{ cost }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <router-link to="/profile/business/advertising/priority/order">
          <button class="btn btn-secondary back-button">Back</button>
        </router-link>
      </div>
      <div class="col-md-6">
        <router-link to="/profile/business/advertising/priority/checkout">
          <button class="btn btn-primary" v-on:click="syncData">Review Your Order</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      showPlaceAlert: false,
      cost: null,
      loading: false,
      specialties: {},
      selectedCategories: []
    }
  },
  computed: {
    ...mapGetters('products', [
      'getProduct'
    ]),
    ...mapGetters('business', [
      'getSelectedServices',
      'getSpecialties'
    ]),
    selectedSpecialties: {
      get () {
        return this.getSpecialties
      },
      set (value) {
        this.updateSpecialties(value)
      }
    },
    productType: {
      get () {
        if (this.getProduct === 'pro') {
          return true
        } else {
          return false
        }
      },
      set (value) {
        if (value) {
          this.updateProduct('pro')
        } else {
          this.updateProduct('basic')
        }
      }
    }
  },
  methods: {
    ...mapMutations('business', [
      'updateSpecialties'
    ]),
    ...mapMutations('products', [
      'updateProduct'
    ]),
    ...mapActions('products', [
      'getPrice'
    ]),
    ...mapActions('business', [
      'syncData'
    ]),
    async getServices (selectedCategories) {
      var client = this.$store.getters.getBusinessApigClientFactory
      var params = {}
      var pathTemplate = '/businesses/services'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        'categories': selectedCategories
      }
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.specialties = result.data.services
      } catch (error) {
        console.log(error)
      }
    },
    async checkPrice () {
      this.loading = true
      try {
        this.cost = await this.getPrice()
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  },
  watch: {
    getProduct: async function () {
      await this.checkPrice()
    }
  },
  created () {
    if (!this.getProduct) {
      this.updateProduct('basic')
    }
    this.checkPrice()
    this.selectedCategories = this.getSelectedServices
    this.getServices(this.selectedCategories)
  }
}
</script>

<style scoped>
.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.remove-button {
  margin-right: 1rem;
  margin-top: .5rem;
}

.btn-primary, .back-button, .btn-full-width {
  width: 100%;
}

.row-margin {
  margin-bottom: 1rem;
}

.row-margin-top {
  margin-top: 1rem;
}

.total-cost {
  background-color: white;
  padding-top: .5rem;
  padding-bottom: .5rem;
  border-radius: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FEEDAA;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/priority/subnavItems/Specialties.vue